export default (that) => [
  {
    text: that.$l('menu_label_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_label_edit') || '编辑面料',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ fabricRequestStatus }) => {
      return !['N', 'B'].includes(fabricRequestStatus)
    },
  },
  {
    text: that.$l('menu_label_delete') || '删除面料',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ fabricRequestStatus }) => {
      return !['N', 'B'].includes(fabricRequestStatus)
    },
  },
  {
    text: that.$l('menu_label_apply') || '提交审核',
    icon: 'el-icon-s-check',
    menuType: 'apply',
    divided: true,
    allow: 'C',
    disabled: ({ fabricRequestStatus, fabricAgentCode }) => {
      return (
        !['N', 'B'].includes(fabricRequestStatus) ||
        fabricAgentCode != that.userInfo.userCode
      )
    },
  },
  {
    text: that.$l('menu_label_printer') || '打印面料',
    icon: 'el-icon-printer',
    menuType: 'printer',
    allow: 'P',
    disabled: ({ fabricRequestStatus }) => !['Y'].includes(fabricRequestStatus),
  },
]
